module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?$!./node_modules/jquery/dist/jquery.js-exposed
// module id = 269
// module chunks = 48